// Markdown in synced descriptions, flattened for places a rendered link can't go.

/** `text` with its Markdown reduced to plain words — for places a rendered link can't go,
 * like a grid card that is itself one big button. Links keep their label, emphasis and
 * heading/list markers are dropped, and line breaks become spaces. */
export function plainText(text: string): string {
  return text
    .replace(/!?\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/<(https?:\/\/[^>\s]+)>/g, "$1")
    .replace(/(\*\*|__|\*|_|`)(\S(?:.*?\S)?)\1/g, "$2")
    .replace(/^\s{0,3}(#{1,6}\s+|[-*+]\s+|\d+\.\s+|>\s?)/gm, "")
    .replace(/\s+/g, " ")
    .trim();
}
